import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

const app = initializeApp({
  apiKey: "AIzaSyB-prM1EtUzUYHRheHBgUbbLTdL2aFNeIw",
  authDomain: "rifas-8f30d.firebaseapp.com",
  projectId: "rifas-8f30d",
  storageBucket: "rifas-8f30d.appspot.com",
  messagingSenderId: "1054236685020",
  appId: "1:1054236685020:web:60072435e7dfb93fc33a19",
  measurementId: "G-MEEY1KFC50"
});

console.log("environment:", process.env.NODE_ENV);

if (process.env.NODE_ENV === "development") {
  (window as any).FIREBASE_APPCHECK_DEBUG_TOKEN = true;
}

initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider("6LfRtUMsAAAAAAwFn8sHPjsvnV0AR8KIoXiqHvqc"),
  isTokenAutoRefreshEnabled: true
});

export const firestore = getFirestore(app);
export const auth = getAuth(app);